import { Database, Globe, Landmark, Newspaper, Percent, Gauge, DollarSign, TrendingUp } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { CotPositioning } from "@/components/CotPositioning";
import { useLang } from "@/context/LanguageContext";

const SOURCES = (en) => [
  { icon: Globe, name: "Financial Modeling Prep", tag: "FMP", desc: en ? "Economic calendar (consensus & actual), Treasury yield curve, news." : "Calendrier économique (consensus & réel), courbe des taux du Trésor, news." },
  { icon: Percent, name: en ? "FRED (Federal Reserve)" : "FRED (Réserve Fédérale)", tag: "FRED", desc: en ? "Policy rates, CPI inflation, official US macro indicators." : "Taux directeurs, inflation CPI, indicateurs macro officiels US." },
  { icon: Newspaper, name: en ? "Finnhub + RSS feeds" : "Finnhub + Flux RSS", tag: "News", desc: en ? "Live market news: Reuters, CNBC, FT, MarketWatch, etc." : "News de marché en direct : Reuters, CNBC, FT, MarketWatch, etc." },
  { icon: TrendingUp, name: "Yahoo Finance", tag: "Futures", desc: en ? "Fed Funds futures → rate hike/cut probabilities." : "Fed Funds futures → probabilités de hausse/baisse des taux." },
  { icon: DollarSign, name: en ? "Frankfurter (ECB)" : "Frankfurter (BCE)", tag: "FX", desc: en ? "Official exchange rates → currency strength & volatility." : "Taux de change officiels → force & volatilité des devises." },
  { icon: Gauge, name: "CNN Fear & Greed", tag: "Sentiment", desc: en ? "Market risk sentiment index (0–100)." : "Indice de sentiment de risque du marché (0–100)." },
  { icon: Landmark, name: "CFTC — Commitments of Traders", tag: "COT", desc: en ? "Weekly positioning of large speculators (COT)." : "Positionnement hebdomadaire des gros spéculateurs (COT)." },
];

export default function Explorer() {
  const { t, lang } = useLang();
  const sources = SOURCES(lang === "en");
  return (
    <div>
      <PageHeader title={t("page.expTitle")} subtitle={t("page.expSub")} icon={Database} />

      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="data-sources">
        {sources.map((s) => (
          <div key={s.name} className="rounded-lg border border-slate-800 bg-[#0E1118] p-4">
            <div className="mb-2 flex items-center justify-between">
              <s.icon className="h-4 w-4 text-amber-400" />
              <span className="rounded bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-400">{s.tag}</span>
            </div>
            <div className="text-sm font-semibold text-slate-100">{s.name}</div>
            <p className="mt-1 text-xs text-slate-500">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-6">
        <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-white">
          <Landmark className="h-5 w-5 text-purple-400" /> {t("page.expCotTitle")}
        </h2>
        <CotPositioning />
      </div>
    </div>
  );
}
